// extracted by mini-css-extract-plugin
export default {"container_checkbox_delete_folders":"DeleteFolders_container_checkbox_delete_folders__UFIPl","subtitle_notifications":"DeleteFolders_subtitle_notifications__lioR4"};